import React from 'react';
import { Monitor } from 'lucide-react';
export function MobileUnsupported() {
  return <div className="md:hidden fixed inset-0 bg-[#F1F5F9] z-[9999] flex items-center justify-center p-6" data-id="element-3517" data-mp="3e9846f8tcm1a">
      <div className="max-w-md text-center" data-id="element-3518" data-mp="3iajms0t9s6zz">
        <div className="mb-6 flex justify-center" data-id="element-3519" data-mp="3i9i7fk580ycg">
          <div className="w-20 h-20 rounded-full bg-[#E0F2FE] flex items-center justify-center" data-id="element-3520" data-mp="3n2bewfs2qks8">
            <Monitor className="w-10 h-10 text-[#0EA5E9]" data-id="element-3521" data-mp="3s1e9f6afh8ly" />
          </div>
        </div>
        <h1 className="text-[24px] font-semibold text-[#0F172A] mb-3" data-id="element-3522" data-mp="ulciemo3vn8">
          Desktop or Tablet Required
        </h1>
        <p className="text-[14px] text-[#64748B] mb-6 leading-relaxed" data-id="element-3523" data-mp="5teog2mb3ela">
          This application is optimized for desktop and tablet devices. Please
          use a larger screen for the best experience.
        </p>
        <div className="bg-white rounded-lg border border-[#E2E8F0] p-4 shadow-sm" data-id="element-3524" data-mp="27mcn4f2rl1e5">
          <p className="text-[13px] text-[#475569] font-medium mb-2" data-id="element-3525" data-mp="2bluxigwylu2q">
            For the best experience:
          </p>
          <ul className="text-[13px] text-[#64748B] text-left space-y-1.5" data-id="element-3526" data-mp="3eiba3mwxnu0c">
            <li data-id="element-3527" data-mp="39qjhz7y4pg83">• Use a tablet (768px or wider)</li>
            <li data-id="element-3528" data-mp="39oqf83qmzg5d">• Use a desktop computer</li>
            <li data-id="element-3529" data-mp="34qx91apc2m53">• Rotate your device to landscape</li>
          </ul>
        </div>
      </div>
    </div>;
}